import axios from "axios";

export const state = {
    specialties: [],
};

export const getters = {
    specialties: state => state.specialties,
};

export const mutations = {
    setSpecialties(state, newValue) {
        state.specialties = newValue
    },
};

export const actions = {
    fetchSpecialties({ commit }) {
        axios.get('/specialties').then(res => {
            commit('setSpecialties', res.data.specialties)
        })
    },
};
